
const MDAlly = (function($) {
   
   	const cjsObjects = [];

    const onInit = function() {
    	gsap.config({force3D:true, nullTargetWarn:false});
    	gsap.registerPlugin([SplitText]);

    	//let Scrollbar = window.Scrollbar;
    	//let scroll = Scrollbar.init( $(".content-container")[0] , {damping:});

    	initAutoPlayVideoMobile();
    	initSliders();
    	loadCreateJS();

    	$(window).scroll( handleScroll );
    	handleScroll();
    }

    function initAutoPlayVideoMobile() {
    	$('body').on('click touchstart', (e)=>{
	    	$('video').each((i,el)=>{

	    		if( ($(el).data('isNodeVideo') || el.hasAttribute('autoplay')) && !el.playing ) {
	    			el.play();
	    		}
	    		
	    	});
    	});
    }

    function initSliders() {
    	$('.mobile-slider, .mobile-image-slider').each((i,el)=>{
    		const p = $(el).parent();
    		const slider = $(el).hasClass('mobile-image-slider') ? $('<div class="mobile-image-slider hide-for-medium"></div>') : $('<div class="mobile-slider hide-for-medium"></div>');
    		$(el).removeClass('mobile-image-slider').removeClass('mobile-slider').addClass('show-for-medium');
    		p.append( slider );

    		$(el).children().each((i,ell)=>{
    			slider.append( $(ell).clone() );
    		});

    		slider.slick({
    			  slidesToScroll: 1,
				  speed: 800,
				  arrows: false, 
				  dots: true,
				  infinite: true,
				  slidesToShow: 1.02
    		});

    	});
    }

    function loadCreateJS() {
    	createjs.Ticker.framerate = 24;
		createjs.Ticker.addEventListener("tick", function(e){
			for( var i = 0 ; i < cjsObjects.length ; i++ ) {
				if( cjsObjects[i].updatable) {
					cjsObjects[i].s.update(e);
				} 
			}
		}); 

    	$('canvas.createjs').each((i,el)=>{
    		
    		var cjsLoader = (function($) {
			    var canvas,
			    	comp,
			    	lib,
			    	images,
			    	exportRoot,
			    	libraryName = '',
			    	script,
			    	imagedir,
			    	loaded = false;

			    var initLoad = function( c ) {
			    	canvas = c; 

			    	libraryName = $(c).data('libname');
			    	imagedir = $(c).data('imagedir');

			    	script = document.createElement('script');
			    	script.type = 'text/javascript';
			    	script.id = libraryName;
			    	script.async = true;
				    script.onreadystatechange = script.onload = onScriptLoaded;
			    	script.src = $(c).data('src') + '?d='+ new Date().valueOf();
			    	document.body.append(script);
			    } 
 
			    function onScriptLoaded(e) {
			    		//console.log( 'script loaded ' + libraryName );
			    	var state = script.readyState;
			        if (!loaded && (!state || /loaded|complete/.test(state))) {
			            loaded = true;
			        } else {
			        	return false;
			        }

			        var anComps = Object.keys(AdobeAn.compositions);
			        for( var i = 0 ; i < anComps.length ; i++ ) {
			        	if( AdobeAn.compositions[ anComps[i] ].getLibrary()[libraryName] ) {
			        		comp = AdobeAn.compositions[ anComps[i] ];
			        		lib = comp.getLibrary();
			        	}
			        }

					images = images||{};

					if( lib.properties.manifest && lib.properties.manifest.length > 0 ) {
						for( var i = 0 ; i < lib.properties.manifest.length ; i++ ) {
							lib.properties.manifest[i].src = imagedir + lib.properties.manifest[i].src;
							//console.log(">>"+ lib.properties.manifest[i].src );
						}

						var loader = new createjs.LoadQueue(false);
						loader.addEventListener("fileload", handleImageLoad);
						loader.addEventListener("complete", handleLoadComplete);
						loader.loadManifest(lib.properties.manifest);
					} else {
						handleLoadComplete();
					}
			    }

			    function handleImageLoad(evt) {
			    	var images = comp.getImages();
					if(evt && evt.item.type == "image") { images[evt.item.id] = evt.result; }
			    }

			    function handleLoadComplete(e) {
			    	exportRoot = new lib[libraryName]();

					stage = new lib.Stage(canvas);
					stage.addChild(exportRoot);
					stage.update();
					stage.enableMouseOver();
					
					cjsObjects.push( {name:libraryName , updatable:false, c:canvas , s:stage} );
					
					AdobeAn.compositionLoaded(lib.properties.id);

					$(canvas).data('name' , libraryName);
					$(canvas).data('lib' , lib);
					$(canvas).data('stage' , stage);
					$(canvas).data('exportRoot' , exportRoot);
					$(canvas).data('isReady' , false );

					if( $(canvas).data('onReady') ) setTimeout( ()=>{ 
						stage.update();
						$(canvas).data('isReady' , true );
						$(canvas).data('onReady')();
						stage.update();
						checkCreateJSObjectLocations();
					}, 100 );
			    }

			    return {
			        load: initLoad,
			        lib: lib,
			        exportRoot : exportRoot
			    };
			})($);
			cjsLoader.load( $(el)[0] );

			$(el).data('loader',cjsLoader);

    	});
    }

    function handleScroll() {
    	checkCreateJSObjectLocations();
    }

    function checkCreateJSObjectLocations() {
    	for( var i = 0 ; i < cjsObjects.length ; i++ ) {
			cjsObjects[i].updatable = ( percentWithinViewport(cjsObjects[i].c) > 0 );
		}
    }

    return {
    	init: onInit,
    };

})(jQuery);

jQuery(document).foundation();

jQuery(document).ready(function() {
    MDAlly.init();
    MDAllyMenu.init();
    MDAllyAnimations.init();
	initFancyBox();
	setupSocialLinks();
    
    if( jQuery( 'body.page-home-page' ).length > 0 ) 
    	MDAllyHome.init();
    else if( jQuery( 'body.page-about-us' ).length > 0 ) 
    	MDAllyAboutUs.init();
    else if( jQuery( 'body.page-public-safety' ).length > 0 ) 
    	MDAllySafety.init();
    else if( jQuery( 'body.page-payors' ).length > 0 ) 
    	MDAllyPayors.init();
    else if( jQuery( 'body.page-how-it-works' ).length > 0 ) 
    	MDAllyHowItWorks.init();
	else if( jQuery( 'body.page-insights' ).length > 0 ) 
		MDAllyInsights.init();
    else 
    	jQuery('body').css('opacity',1);
    
	jQuery(document).on('nfFormReady', function(){
		jQuery('.nf-field-element input, .nf-field-element select').on("focus", function(){
			jQuery(this).parent().parent().find("label").addClass("input-active");
		}).on("focusout", function(){
			if(jQuery(this).val() == ""){
				jQuery(this).parent().parent().find("label").removeClass("input-active");
			}
		});
	});

	jQuery('body').on("focusin change", '.hs-form-field input, .hs-form-field select', function(){
		if(jQuery(this).val() == "" || jQuery(this).val() == null){
			jQuery(this).parent().parent().find("label").addClass("input-active");
		}
	}).on("focusout", function(e){
		var input = jQuery(e.target);
		if(input.val() == ""){
			input.parent().parent().find("label").removeClass("input-active");
		}
	});

	
	
});

function initFancyBox(){
	jQuery(".team-member-modal-launch").fancybox({
		parentEl: 'body',
		margin: [0, 0],
		closeExisting: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
				'<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" fill="#D25151"/><rect x="16.5146" y="15" width="26" height="2" rx="1" transform="rotate(45 16.5146 15)" fill="#EEEDEA"/><rect x="15.1005" y="33" width="26" height="2" rx="1" transform="rotate(-45 15.1005 33)" fill="#EEEDEA"/></svg>' +
				"</button>"
		},
		beforeShow: function(){
		},
		afterShow: function (){
		},
		beforeClose: function () {
		}
	});

	jQuery(".request-meeting a").fancybox({
		parentEl: 'body',
		margin: [0, 0],
		closeExisting: true,
		autofocus: false,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
				'<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" fill="#D25151"/><rect x="16.5146" y="15" width="26" height="2" rx="1" transform="rotate(45 16.5146 15)" fill="#EEEDEA"/><rect x="15.1005" y="33" width="26" height="2" rx="1" transform="rotate(-45 15.1005 33)" fill="#EEEDEA"/></svg>' +
				"</button>"
		},
		beforeShow: function(){
			//change copy in the modal window
			jQuery('#request-a-meeting #nf-field-5_1-wrap h3 #request-a-meeting .hs-richtext h3').text("Request a Meeting");
			jQuery('#request-a-meeting #nf-field-5_1-wrap p, #request-a-meeting .hs-richtext p').text("Meet with a member of our team to explore partnership opportunities with MD Ally.");
		},
		afterShow: function (){
		},
		beforeClose: function () {
		}
	});
	
	//hubspot form submitted
	window.addEventListener('message', event => {
		if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit'){
			jQuery('#request-a-meeting .inner').append('<div class="hs-response-msg"><button class="button btn is-style-outline close-button" data-fancybox-close="">Close</button></div>');
		}
	});
	

}


function setupSocialLinks(){
	jQuery('.facebook-share a').each(function(){
		if(jQuery(this).data("url") != "" && jQuery(this).data("url") != undefined){
			jQuery(this).attr("href", 'http://www.facebook.com/share.php?u='+encodeURIComponent(jQuery(this).data("url"))).attr("target", "_blank");
		}else{
			jQuery(this).attr("href", 'http://www.facebook.com/share.php?u='+encodeURIComponent(location.href)).attr("target", "_blank");
		}
	});

	jQuery('.twitter-share a').each(function(){
		if(jQuery(this).data("url") != "" && jQuery(this).data("url") != undefined){
			jQuery(this).attr("href", 'http://www.twitter.com/share?url='+encodeURIComponent(jQuery(this).data("url"))).attr("target", "_blank");
		}else{
			jQuery(this).attr("href", 'http://www.twitter.com/share?url='+encodeURIComponent(location.href)).attr("target", "_blank");
		}
	});

	jQuery('.linkedin-share a').each(function(){
		if(jQuery(this).data("url") != "" && jQuery(this).data("url") != undefined){
			jQuery(this).attr("href", 'https://www.linkedin.com/sharing/share-offsite/?url='+encodeURIComponent(jQuery(this).data("url"))).attr("target", "_blank");
		}else{
			jQuery(this).attr("href", 'https://www.linkedin.com/sharing/share-offsite/?url='+encodeURIComponent(location.href)).attr("target", "_blank");
		}
	});
}